import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const PerPageSkeleton = () => {
  return <Skeleton className='w-24 h-5' />;
};

export default PerPageSkeleton;
